import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Total Revenue YTD',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: '',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'revenue',
                          points: {
                            '@': 'barchartPoints',
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    barchartPoints: {
      target: 'ent:!org:!div',
      selection: {
        '{}': {
          x: {
            '@.': '!name',
          },
          y: {
            '+': {
              '->': [
                {
                  '@': 'yearToDateGlExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'revenueAmount',
                  ],
                },
              ],
            },
          },
        },
      },
      subqueries: {
        yearToDateGlExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!org',
            inherit: '-',
          },
          period: {
            $range: {
              end: {
                $date: '4/28/2026',
              },
              start: {
                $date: '1/1/2026',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              expenseAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'Expense',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              revenueAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'Revenue',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!name',
              },
            },
          },
        },
      },
    },
  },
}
